import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import DataTable from "../components/DataTable";
import { formatIDR, formatPercent, formatDate } from "../lib/format";

export default function Exposures() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/exposures").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load once on mount

  return (
    <div className="p-8 max-w-[1600px] mx-auto" data-testid="exposures-page">
      <PageHeader title="Eksposur" subtitle={`${data.length} exposure record terkini`} />
      {loading ? <div className="text-sm text-muted-foreground">Memuat…</div> : (
        <DataTable
          testId="exposures-table"
          searchKeys={["exposure_id", "facility_id"]}
          columns={[
            { header: "Exposure ID", cell: (r) => <span className="mono">{r.exposure_id}</span> },
            { header: "Facility ID", cell: (r) => <span className="mono">{r.facility_id}</span> },
            { header: "Outstanding", cell: (r) => formatIDR(r.outstanding_amount, { compact: true }), align: "right" },
            { header: "Undrawn", cell: (r) => formatIDR(r.undrawn_commitment, { compact: true }), align: "right" },
            { header: "EAD", cell: (r) => formatIDR(r.ead, { compact: true }), align: "right" },
            { header: "PD", cell: (r) => formatPercent(r.pd, 2), align: "right" },
            { header: "LGD", cell: (r) => formatPercent(r.lgd, 2), align: "right" },
            { header: "Expected Loss", cell: (r) => formatIDR(r.expected_loss, { compact: true }), align: "right" },
            { header: "Reporting Date", cell: (r) => <span className="mono text-xs">{formatDate(r.reporting_date)}</span> },
          ]}
          data={data}
          pageSize={15}
        />
      )}
    </div>
  );
}
